const vehicleMarkerPopup = {
  batteryLevel: ' Nivel de batería', 
  estimatedRange: 'Intervalo estimado',
  chargingStatus: 'Estado de carga',
  charging: 'Cargando',
  notCharging: 'No cargando',
  unknown: 'desconocido',
};

export default vehicleMarkerPopup;